import { AfterViewChecked, Component, forwardRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ]
})
export class TextareaComponent implements AfterViewChecked {
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() minlength: number = 5;
  @Input() maxlength: number = 255;
  @Input() disabled: boolean = false;
  
  @Input() required: boolean = false;
  @Input() model: any;
  @Input() loading: boolean = false;

  @ViewChild('inputModel', { static: true }) inputModel!: NgModel;

  value: any = '';
  

  ngAfterViewChecked() {
    if (this.inputModel && this.value !== this.inputModel.value) {
      // console.log(this.value, 'chaged');
      this.writeValue(this.value);
    }
  }

  onChange(value: any) {
    this.value = value;
    if (this.onChangeCallback) {
      this.onChangeCallback(value);
    }
  }
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
    this.model = value;
    // this.inputModel.control.setValue(value);
  }

  private onChangeCallback: any = () => { };

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn; // Save the provided callback function
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Handle disabled state if needed
  }

  markAsTouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsTouched();
    }
  }

  markAsUntouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsUntouched();
    }
  }

}
